import useServiceFactory from "../serviceFactory";
const apiUrl = `/operaciones/tarifasPermisionarios`;
const useApitarifaPermisionarios  = () => {
    const service = useServiceFactory({ uri: process.env.REACT_APP_API_URL });
    return {
        filtrar: async (params) => service.get(`${apiUrl}`, {params}),
        obtener: async (id) => service.get(`${apiUrl}/${id}`, {showLoading: true}),
        guardar: async (payload) => service.post(`${apiUrl}`, payload),
        actualizar: async (id,params) => service.put(`${apiUrl}/${id}`, params)  
    }
};

export default useApitarifaPermisionarios;
